

























































import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'FloatingStepsDesktop',
  components: {
    Block,
  },
  props: {
    mainGoals: {
      type: Array,
    },
  },
  data: () => ({
    menuSizes: {
      xs: 1000,
      sm: 1000,
      md: 252,
      lg: 326,
      xl: 326,
    },
  }),
})
